import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CapitanLocation } from '../../../../../../../../models/location';
import { EntryPass, EntryPassLocationSpecificPricingMatrix } from '../../../../../../../../models/entry-pass';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-edit-entry-pass-per-location-pricing-matrix-modal',
  templateUrl: './edit-entry-pass-per-location-pricing-matrix-modal.component.html',
  styleUrls: ['./edit-entry-pass-per-location-pricing-matrix-modal.component.css']
})
export class EditEntryPassPerLocationPricingMatrixModalComponent implements OnInit {
  @Input() inputPricingMatrix: EntryPassLocationSpecificPricingMatrix = null;
  @Input() entryPass: EntryPass;
  @Input() locations: CapitanLocation[];
  @Input() completedCallback: (result: EntryPassLocationSpecificPricingMatrix) => undefined;

  public pricingMatrix: EntryPassLocationSpecificPricingMatrix;

  public errors: any = {};
  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService,
  ) {}

  ngOnInit() {
    this.setInitialPricingMatrix();
  }

  public toggleLocationId(locationId: number) {
    if (this.pricingMatrix.location_ids.includes(locationId)) {
      this.pricingMatrix.location_ids.splice(
        this.pricingMatrix.location_ids.indexOf(locationId),
        1
      );
    } else {
      this.pricingMatrix.location_ids.push(locationId);
    }
  }

  public handleSubmit() {
    this.errors = {};
    this.errorMessage = '';

    if (Object.keys(this.errors).length > 0) {
      this.errorMessage = 'Please correct the errors shown and try again.';
      return;
    }

    this.completedCallback(this.pricingMatrix);
    this.activeModal.close();
  }

  private setInitialPricingMatrix() {
    if (this.inputPricingMatrix) {
      this.pricingMatrix = {
        location_ids: Object.assign([], this.inputPricingMatrix.location_ids),
        price: this.inputPricingMatrix.price,
      };
    } else {
      this.pricingMatrix = {
        location_ids: [],
        price: this.entryPass.price.toString(),
      };
    }
  }
}
